export enum DesignConsoleRouteName {
  Templates = 'templates',
  Layout = 'layout',
  Color = 'color',
  Details = 'details',
  Art = 'art',
  Font = 'font',
  Css = 'css',
}

// Intended to be Pick<UseDesignConsoleRouterReturn, 'goTo' | 'goToDetailsTab'>
// However, Referencing UseDesignConsoleRouterReturn leads to a circular import.
type DesignConsoleRouteComponentProps = {
  goTo: (tabValue: string) => void;
  goToDetailsTab: () => void;
};

export type DesignConsoleRoute = {
  name: `${DesignConsoleRouteName}`;
  component: (args: DesignConsoleRouteComponentProps) => React.ReactElement;
  label: string;
  icon: React.ReactElement;
};

export type DesignConsoleTelemetryRouteName = (typeof DesignConsoleRouteName)[keyof typeof DesignConsoleRouteName];

export type DesignConsoleTelemetryRoutes = DesignConsoleTelemetryRouteName | 'fullScreenPreview' | 'websiteDesignerPrintCrossSellDialog';
